import type { SvelteActionArray, SvelteActionReturn } from "./index";

export function useActions(element: HTMLElement, actions: SvelteActionArray) {
  let actionResults: SvelteActionReturn[] = [];

  actions?.forEach((actionEntry) => {
    if (Array.isArray(actionEntry)) {
      const [action, params] = actionEntry;
      actionResults.push(action(element, params));
    } else {
      actionResults.push(actionEntry(element));
    }
  });

  return {
    update(updatedActions: SvelteActionArray) {
      updatedActions?.forEach((actionEntry, i) => {
        if (actionResults[i]) {
          const params = Array.isArray(actionEntry) ? actionEntry[1] : undefined;
          (actionResults[i] as Exclude<SvelteActionReturn, void>)?.update?.(params);
        }
      });
    },

    destroy() {
      actionResults.forEach((actionResult) =>
        (actionResult as Exclude<SvelteActionReturn, void>)?.destroy?.(),
      );
    },
  };
}
